// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-wrapper {
  position: relative;
  margin-right: 6px;
}
.dropdown-wrapper .dropdown-btn {
  display: flex;
  align-items: center;
  color: #586f80;
  outline: none;
  border-radius: 50px;
  line-height: 20px;
}
.dropdown-wrapper .dropdown-btn span {
  display: flex;
}
.dropdown-wrapper .dropdown-btn:focus, .dropdown-wrapper .dropdown-btn:hover {
  color: #586f80;
  border: 1px solid #586f80;
}
.dropdown-wrapper .dropdown-btn.active-filter {
  background-color: #eef3fc !important;
  color: #004195 !important;
  border: 1px solid #004195 !important;
}
.dropdown-wrapper .dropdown-btn.active-filter:hover {
  background-color: #e0e8f5 !important;
  color: #004195 !important;
  border: 1px solid #004195 !important;
}
.dropdown-wrapper .active {
  background-color: #586f80;
  color: #fff;
}
.dropdown-wrapper .active:hover {
  background-color: #586f58;
  color: #fff;
}
.dropdown-wrapper .checkbox-wrapper {
  position: absolute;
  z-index: 1;
  background: #fff;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);
  width: 160px;
  font-size: 16px;
  overflow: visible;
}
.dropdown-wrapper .checkbox-wrapper .ant-checkbox-wrapper,
.dropdown-wrapper .checkbox-wrapper .ant-radio-wrapper,
.dropdown-wrapper .checkbox-wrapper .ant-input,
.dropdown-wrapper .checkbox-wrapper .dropdown-footer .ant-btn {
  font-size: 16px;
}
.dropdown-wrapper .checkbox-wrapper .ant-checkbox-group {
  display: flex;
  flex-direction: column;
}
.dropdown-wrapper .checkbox-wrapper .ant-checkbox-group .ant-checkbox-group-item {
  margin: 0;
}
.dropdown-wrapper .checkbox-wrapper .ant-checkbox-group .ant-checkbox-group-item span {
  color: #0a0a14;
}
.dropdown-wrapper .checkbox-wrapper .clear-btn-wrapper {
  display: flex;
  justify-content: space-between;
}
.dropdown-wrapper .checkbox-wrapper .clear-btn-wrapper .clear-btn {
  background-color: #fff;
  border: none;
  padding: 8px 12px;
  color: #767676;
  letter-spacing: 0.8px;
  cursor: pointer;
}
.dropdown-wrapper .checkbox-wrapper .clear-btn-wrapper .clear-btn:hover {
  color: #586f80;
}
.dropdown-wrapper .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #586f80;
  border-color: #586f58;
}
.dropdown-wrapper .ant-checkbox-wrapper:hover .ant-checkbox-inner,
.dropdown-wrapper .ant-checkbox:hover .ant-checkbox-inner,
.dropdown-wrapper .ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #586f58;
}
.dropdown-wrapper li {
  list-style: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Dropdown/dropdown.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AACJ;AACI;EACE,aAAA;AACN;AAEI;EAEE,cAAA;EACA,yBAAA;AADN;AAII;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;AAFN;AAIM;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;AAFR;AAOE;EACE,yBAAA;EACA,WAAA;AALJ;AAOI;EACE,yBAAA;EACA,WAAA;AALN;AASE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,2CAAA;EACA,YAAA;EACA,eAAA;EAGA,iBAAA;AATJ;AAWI;;;;EAIE,eAAA;AATN;AAYI;EACE,aAAA;EACA,sBAAA;AAVN;AAYM;EACE,SAAA;AAVR;AAYQ;EACE,cAAA;AAVV;AAeI;EACE,aAAA;EACA,8BAAA;AAbN;AAeM;EACE,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AAbR;AAeQ;EACE,cAAA;AAbV;AAmBE;EACE,yBAAA;EACA,qBAAA;AAjBJ;AAoBE;;;EAGE,qBAAA;AAlBJ;AAqBE;EACE,gBAAA;AAnBJ","sourcesContent":[".dropdown-wrapper {\n  position: relative;\n  margin-right: 6px;\n\n  .dropdown-btn {\n    display: flex;\n    align-items: center;\n    color: #586f80;\n    outline: none;\n    border-radius: 50px;\n    line-height: 20px;\n\n    span {\n      display: flex;\n    }\n\n    &:focus,\n    &:hover {\n      color: #586f80;\n      border: 1px solid #586f80;\n    }\n\n    &.active-filter {\n      background-color: #eef3fc !important;\n      color: #004195 !important;\n      border: 1px solid #004195 !important;\n\n      &:hover {\n        background-color: #e0e8f5 !important;\n        color: #004195 !important;\n        border: 1px solid #004195 !important;\n      }\n    }\n  }\n\n  .active {\n    background-color: #586f80;\n    color: #fff;\n\n    &:hover {\n      background-color: #586f58;\n      color: #fff;\n    }\n  }\n\n  .checkbox-wrapper {\n    position: absolute;\n    z-index: 1;\n    background: #fff;\n    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);\n    width: 160px;\n    font-size: 16px;\n    // The option list owns scrolling. Keeping the menu itself non-scrollable\n    // prevents the nested scrollbars shown in long filters.\n    overflow: visible;\n\n    .ant-checkbox-wrapper,\n    .ant-radio-wrapper,\n    .ant-input,\n    .dropdown-footer .ant-btn {\n      font-size: 16px;\n    }\n\n    .ant-checkbox-group {\n      display: flex;\n      flex-direction: column;\n\n      .ant-checkbox-group-item {\n        margin: 0;\n\n        span {\n          color: #0a0a14;\n        }\n      }\n    }\n\n    .clear-btn-wrapper {\n      display: flex;\n      justify-content: space-between;\n\n      .clear-btn {\n        background-color: #fff;\n        border: none;\n        padding: 8px 12px;\n        color: #767676;\n        letter-spacing: 0.8px;\n        cursor: pointer;\n\n        &:hover {\n          color: #586f80;\n        }\n      }\n    }\n  }\n\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: #586f80;\n    border-color: #586f58;\n  }\n\n  .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n  .ant-checkbox:hover .ant-checkbox-inner,\n  .ant-checkbox-input:focus+.ant-checkbox-inner {\n    border-color: #586f58;\n  }\n\n  li {\n    list-style: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
